import { SVGProps, useContext } from "react"
import { CanvasControlsContext } from "@/components/canvas-controls/CanvasControlsContext"
import { AnchorPoint } from "@/components/canvas-controls/canvas-controls-utils"
import clsx from "clsx"

interface HandleProps extends SVGProps<SVGEllipseElement> {
	x: number
	y: number
	size?: number
	anchor?: AnchorPoint
	isTransparent?: boolean
}

export const Handle = ({
	x,
	y,
	size = 12,
	isTransparent = false,
	className,
	...props
}: HandleProps) => {
	const { parentX, parentY, parentWidth, parentHeight } = useContext(CanvasControlsContext)

	const cx = parentX + x * parentWidth
	const cy = parentY + y * parentHeight

	return (
		<>
			{!isTransparent && (
				<ellipse
					cx={cx}
					cy={cy}
					rx={size * 0.5}
					ry={size * 0.5}
					fill="white"
					stroke="rgba(0,0,0,0.3)"
					strokeWidth={1}
					className={clsx("pointer-events-none", className)}
				/>
			)}
			<ellipse
				cx={cx}
				cy={cy}
				rx={(size + 10) * 0.5}
				ry={(size + 10) * 0.5}
				fill="transparent"
				data-anchor={props.anchor}
				className={clsx("cursor-move", className)}
				{...props}
			/>
		</>
	)
}
